import { mutationOptions } from '@tanstack/react-query';
import { queryClient } from 'merchant-api';
import type { Application } from 'merchant-api/types';
import { unifiedApiClient, UnifiedApiError, UnifiedApiNetworkError } from '..';

export type OTPResponse = {
  appId?: string;
  associate?: boolean;
  emailMasked: string;
  key: string;
  redirect?: string;
  error?: string;
};

export const isOTPResponse = (data: unknown): data is OTPResponse =>
  ['emailMasked', 'key'].every((key) => typeof (data as Record<string, unknown> | null)?.[key] === 'string');

export const getAuthRedirect = (data: { appId?: string; associate?: boolean; redirect?: string }) => {
  if (data.redirect?.trim()) return data.redirect;
  if (data.appId) return `/application/${data.appId}`;

  return '/application';
};

export const toOTPSearch = (data: OTPResponse) => ({
  emailMasked: data.emailMasked,
  key: data.key,
  redirect: getAuthRedirect(data),
});

export const createApplication = async (data: any): Promise<Application | OTPResponse> => {
  const post = unifiedApiClient.POST as any;
  const result = await post('/public/application/v1/create', { body: data });

  if (result.data) {
    if (!isOTPResponse(result.data)) {
      const application = result.data as Application;
      queryClient.setQueryData(['app'], application);
      queryClient.setQueryData(['app', application.id], application);
      return application;
    }

    return result.data as OTPResponse;
  }

  throw new UnifiedApiError(result.response.clone(), result.response, result.error);
};

export const createApplicationOptions = () =>
  mutationOptions<unknown, UnifiedApiError | UnifiedApiNetworkError, any>({
    mutationFn: createApplication,
  });
